import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const navLinks = [
  { title: "Beranda", href: "#beranda" },
  { title: "Tentang", href: "#tentang-kami" },
  { title: "Layanan", href: "#layanan" },
  { title: "Galeri", href: "#galeri" },
  { title: "Berita", href: "#berita" },
  { title: "Kontak", href: "#kontak" },
];

function NavBar({ onOpenLogin }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const sections = navLinks.map((link) =>
        document.getElementById(link.href.substring(1))
      );
      const scrollPosition = window.scrollY + 150;

      for (const section of sections) {
        if (
          section &&
          section.offsetTop <= scrollPosition &&
          section.offsetTop + section.offsetHeight > scrollPosition
        ) {
          setActiveLink(`#${section.id}`);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLinkClick = () => setIsMenuOpen(false);

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/50 backdrop-blur-lg border-b border-white/40 shadow-lg z-[100]">
      <div className="container mx-auto px-6 py-3 flex items-center justify-between">
        {/* Logo dan Nama */}
        <div className="flex items-center space-x-3">
          <img src="/images/foto.png" alt="Logo" className="w-10 h-10" />
          <span
            className="font-extrabold text-lg bg-gradient-to-r from-green-600 via-emerald-500 to-teal-600 
                       bg-clip-text text-transparent tracking-wide drop-shadow-sm"
          >
            SONEY RAYA
          </span>
        </div>

        {/* Menu Desktop */}
        <ul className="hidden md:flex items-center space-x-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`transition-colors duration-300 font-medium pb-1 border-b-2 
                hover:text-green-600 hover:border-green-500 ${
                  activeLink === link.href
                    ? "text-green-600 border-green-500"
                    : "text-gray-700 border-transparent"
                }`}
              >
                {link.title}
              </a>
            </li>
          ))}
        </ul>

        {/* Tombol Login */}
        <button
          onClick={onOpenLogin}
          className="hidden md:inline-block bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700 
                     text-white font-semibold px-5 py-2 rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
        >
          Login
        </button>

        {/* Toggle Menu Mobile */}
        <div className="md:hidden">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle Menu"
          >
            {isMenuOpen ? (
              <X className="w-6 h-6 text-gray-800" />
            ) : (
              <Menu className="w-6 h-6 text-gray-800" />
            )}
          </button>
        </div>
      </div>

      {/* Menu Mobile */}
      <div
        className={`absolute left-0 right-0 w-full bg-white shadow-xl md:hidden transition-all duration-300 ease-in-out overflow-hidden ${
          isMenuOpen ? "max-h-96 py-4" : "max-h-0"
        }`}
      >
        <ul className="flex flex-col items-center space-y-4">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={handleLinkClick}
                className={`transition-colors duration-300 font-medium text-lg hover:text-green-600 ${
                  activeLink === link.href
                    ? "text-green-600"
                    : "text-gray-700"
                }`}
              >
                {link.title}
              </a>
            </li>
          ))}
          <li>
            <button
              onClick={onOpenLogin}
              className="mt-2 inline-block bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700 
                         text-white font-semibold px-6 py-2 rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
            >
              Login
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;
